import React from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  LocationCity,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  sploshingPageAdditionalMeta,
  sploshingPageStructuredData,
} from '../../utils/data/MetaData';
// Images
import MainImage from '../../assets/images/main/main-half.png';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import SploshingPageMainContainer from '../../components/sploshing/SploshingPageMainContainer';
import ServiceHeader from '../../components/general/ServiceHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function SploshingPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Sploshing & Messy Play'
        desc={`Indulge in the messy, playful, and sensual world of sploshing with ${CompanyName}. A feast for the senses, where pleasure meets chaos.`}
        keywords={KeywordsPages}
        additionalMeta={sploshingPageAdditionalMeta}
        structuredData={sploshingPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <ServiceHeader
            title={`Sploshing`}
            subtitle={`Dare you get messy with me?`}
            imageUrl={`bg-sploshing`}
          />

          {/* Main page content */}
          <SploshingPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default SploshingPage;
